// The native pattern attribute and the JS filter must accept the same set:
// a-z, A-Z, 0-9, extended Latin (accents), whitespace, & ' , _ @ . + -
export const SEARCH_INPUT_PATTERN = "[a-zA-Z0-9\\u00C0-\\u017F\\s&',_@.+\\-]*";

export const ALLOWED_SEARCH_CHARS_REGEX = /[a-zA-Z0-9À-ſ\s&',_@.+-]/g;

export const filterSearchInput = (value: string): string => {
  const matches = value.match(ALLOWED_SEARCH_CHARS_REGEX);
  return matches ? matches.join('') : '';
};
